import { apiFetch } from './client';

export type KbAudience = 'admin' | 'reseller' | 'customer' | 'end-user';

export interface KbArticle {
  slug: string;
  title: string;
  audiences: KbAudience[];
}

export interface KbArticleDetail extends KbArticle {
  markdown: string;
}

export const knowledgeBase = {
  list: () => apiFetch<{ rows: KbArticle[] }>('/api/docs'),
  get: (slug: string) => apiFetch<KbArticleDetail>(`/api/docs/${slug}`),
};
